import React from 'react';

export function HupalupaStoreHaziran2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA STORE — ₺500,000 — Haziran 2026                               */}
      {/* Karne kampanyası + Karne hediyesi + Büyük yaz kampanyası               */}
      {/* Google Ads + Meta Ads + TikTok Ads (YouTube & TikTok eklendi)          */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-2">
              <img src="https://hupalupa.store/Data/EditorFiles/Devux/logo-1.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Haziran 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + PMAX + Shopping + YouTube) • Meta Ads (Sales + Traffic + Video) • TikTok Ads</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Haziran 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺500,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-rose-50 border border-rose-200">
            <p className="text-xs font-semibold text-rose-800 mb-1">Haziran Odağı — Karne & Yaz</p>
            <p className="text-[11px] text-rose-700 leading-relaxed">
              Ay, üç ana kampanya etrafında kurgulanıyor: <strong>(1) Karne kampanyası</strong>, <strong>(2) Karne hediyesi odaklı iletişim</strong> ve <strong>(3) Büyük yaz kampanyası</strong>.
              Satış (Advantage+ Catalog) bütçesi korunurken, marka talebini büyütmek için ilk kez <strong>YouTube</strong> ve <strong>TikTok</strong> video kanalları STORE tarafına dahil ediliyor.
            </p>
          </div>

          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺210,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">42% • Search + PMAX + Shopping + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺270,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">54% • Sales + Catalog + Traffic + Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺20,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">4% • Video + Traffic</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺30,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">Google Ads YouTube Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">105.9K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Google 42.2K + Meta 62.0K + TikTok 1.7K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Meta Sales Focus</span>
              <p className="text-xl font-bold text-emerald-800">₺210K</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">50.0K tahmini conversion click</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — HUPALUPA STORE Haziran 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Type</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Impressions</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPC (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPM (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search (Karne Hediyesi + Generic)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">15,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺75,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Performance Max (Yaz Kampanyası)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">15,556</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺70,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Shopping</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">11,667</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺35,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">YouTube Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">250,000 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.12 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Google Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">42,223</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺210,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Sales (Advantage+ & Catalog)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">50,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.2</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺210,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">12,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺2.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views (Yaz Kampanyası)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">333,333 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.09 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">62,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺4.4</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺270,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={2}>
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">In-Feed / Spark Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">250,000 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.06 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic (VSA)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">1,667</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺5,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold">
                    <td className="px-4 py-3 text-sm text-gray-800">TikTok Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">1,667</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">₺20,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm">Grand Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">105,890</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺500,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Hedefleme & Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Hedefleme & Strateji — HUPALUPA STORE</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Karne Kampanyası</p>
                <p className="leading-relaxed">"Karne hediyesi" arama niyetini yakalamak için Search + Shopping; ebeveyn (25-45) + hediye arayan kitle. Karne haftasında (ay ortası) bütçe yoğunlaştırılır.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Karne Hediyesi İletişimi</p>
                <p className="leading-relaxed">Meta Advantage+ Catalog ile ürün-bazlı dinamik remarketing + hediye kategorileri; ilgi alanı: oyuncak, çocuk gelişimi, hediye. Lookalike (satın alanlar) %1-3.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Büyük Yaz Kampanyası</p>
                <p className="leading-relaxed">YouTube + TikTok + Meta Video ile yaz koleksiyonu farkındalığı; geniş kitle prospecting, video izleyenler retargeting havuzuna aktarılır (full-funnel).</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  Haziran ayında karne dönemi ve yaz kampanyası odaklı; YouTube ve TikTok video kanalları STORE markası için bu ay devreye alınmıştır.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export function HupalupaEglenceHaziran2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA — ₺350,000 — Haziran 2026                                     */}
      {/* "En Güzel Karne Hediyesi HUPALUPA Eğlencesi" — Oyun alanları + Atölye  */}
      {/* Google Ads + Meta Ads + TikTok Ads (YouTube & TikTok artırıldı)        */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-1.5">
              <img src="https://hupalupa.com.tr/images/logo_s.png" alt="Hupalupa" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA — Haziran 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + GDN + YouTube) • Meta Ads (Engagement + Reach + Traffic + Video) • TikTok Ads</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Haziran 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺350,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-violet-50 border border-violet-200">
            <p className="text-xs font-semibold text-violet-800 mb-1">Haziran Odağı — "En Güzel Karne Hediyesi HUPALUPA Eğlencesi"</p>
            <p className="text-[11px] text-violet-700 leading-relaxed">
              Karne dönemi söylemiyle <strong>oyun alanları</strong> ön plana çıkarılıyor, <strong>atölye içerikleri</strong> destekleyici rol üstleniyor.
              Çocuklara yönelik <strong>oyun platformlarında yer alma</strong> fırsatları değerlendiriliyor; bütçe ağırlığı <strong>Meta'da (etkileşim + erişim)</strong> toplanırken, video (YouTube + TikTok + Meta) destekleyici rol üstleniyor.
            </p>
          </div>

          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺140,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">40% • Search + GDN + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺170,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">48.6% • Engagement + Reach + Traffic + Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺40,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">11.4% • Video + Traffic + Spark</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺50,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">Google Ads YouTube Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">45.9K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Google 20.0K + Meta 21.2K + TikTok 4.8K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Total Reach</span>
              <p className="text-xl font-bold text-emerald-800">2.0M</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Across all channels (June)</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — HUPALUPA Haziran 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Type</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Impressions</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPC (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPM (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search (Karne Eğlencesi + Oyun Alanı)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">15,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺75,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">GDN (Display)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">5,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">YouTube Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">357,143 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.14 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺50,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Google Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">20,000</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺140,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Engagement (Atölye İçerikleri)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">12,222</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺55,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Reach & Frequency (Karne Dönemi)</td>
                    <td className="px-4 py-3 text-sm text-right">3,333,333</td>
                    <td className="px-4 py-3 text-sm text-right">2,000,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺15.0</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺50,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">8,929</td>
                    <td className="px-4 py-3 text-sm text-right">₺2.8</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views (Oyun Alanları)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">400,000 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.10 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺40,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">3,333,333</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">2,000,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">21,151</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺170,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">In-Feed Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">416,667 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.06 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">3,333</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺10,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Spark Ads / Engagement</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">1,429</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺5,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold">
                    <td className="px-4 py-3 text-sm text-gray-800">TikTok Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">4,762</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">₺40,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm">Grand Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right">3,333,333</td>
                    <td className="px-4 py-3 text-sm text-right">2,000,000</td>
                    <td className="px-4 py-3 text-sm text-right">45,913</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺350,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Hedefleme & Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Hedefleme & Strateji — HUPALUPA Eğlence</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Oyun Alanları (Ana Odak)</p>
                <p className="leading-relaxed">Konum bazlı (AVM/şube çevresi 0-15 km) ebeveyn hedeflemesi; YouTube + TikTok + Meta Video ile oyun alanı deneyimi öne çıkar. Karne haftası bütçe yoğunlaşır.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Atölye İçerikleri (Destek)</p>
                <p className="leading-relaxed">Meta Engagement + IG Reels ile atölye/etkinlik içerikleri; ilgi alanı: çocuk gelişimi, sanat-atölye, anaokulu. Etkileşim alanlar retargeting havuzuna eklenir.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Çocuk Oyun Platformları</p>
                <p className="leading-relaxed">Kids-safe içerik/uygulama yerleşimleri (YouTube Kids uyumlu, GDN aile kategorileri) ile yeni kitleye erişim; marka güvenliği filtreleri aktif.</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  Haziran ayında "En Güzel Karne Hediyesi HUPALUPA Eğlencesi" söylemiyle oyun alanları öne çıkarılmış, bütçe ağırlığı Meta (etkileşim + erişim) tarafında toplanmış, video destekleyici rol üstlenmiştir.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

// Birleşik görünüm (her iki Hupalupa markası tek sayfada)
export default function HupalupaHaziran2026() {
  return (
    <div className="space-y-16">
      <HupalupaStoreHaziran2026 />
      <HupalupaEglenceHaziran2026 />
    </div>
  );
}
